import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Dimmer, Icon, Loader, Message, Modal, Popup, Table,
} from 'semantic-ui-react';

import { errorType, keyType } from '../types';
import ConsoleErrorMessage from '../utils/console-error-message';

import { clearError, listKeys } from '../../modules/keys';

import ConnectedKeyAuthModal from './key-auth-modal';
import ConnectedKeysHeaderBar from './keys-header-bar';
import ConnectedKeyTr from './key-tr';

import '../../stylesheets/keys.css';

export class Keys extends Component {
  state = {
    pageError: false,
  }

  componentDidMount() {
    const { connectedClearError, connectedListKeys } = this.props;
    connectedClearError();
    connectedListKeys();
  }

  componentDidUpdate(prevProps) {
    const { error, listKeysRequestOut } = this.props;
    if ((prevProps.listKeysRequestOut === true && listKeysRequestOut === false)
      && error) {
      this.setPageError(true);
    }
  }

  setPageError(pageError) {
    this.setState({ pageError });
  }

  handleCloseError = () => {
    const { connectedClearError } = this.props;
    connectedClearError();
    this.setState({ pageError: false });
  }

  renderKeysTable = () => {
    const { keys } = this.props;
    return (
      <Table padded className="re is-margin-none is-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="four">Created</Table.HeaderCell>
            <Table.HeaderCell width="three">Name</Table.HeaderCell>
            <Table.HeaderCell>Id <Popup trigger={<Icon name="info circle" /> } content="SHA256 hash of key secret" /></Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { keys.map(key => <ConnectedKeyTr apiKey={key} key={key.id} />) }
        </Table.Body>
      </Table>
    );
  }

  renderEmptyState = () => (
    <div className="re is-flex is-flex-align-center is-justifyContent-center is-marginTop-32px">
      <Message>
        <Message.Header>
            API Keys
        </Message.Header>
        <p>
            You need API keys to use the Remeeting API.
            Click on &apos;Create a Key&apos; above to get started.
        </p>
      </Message>
    </div>
  )

  renderErrorModal = () => {
    const { error } = this.props;
    const { pageError } = this.state;
    return (
      <Modal
        onClose={this.handleCloseError}
        open={pageError}
      >
        <Modal.Header>Error</Modal.Header>
        <Modal.Content>
          <ConsoleErrorMessage error={error} />
        </Modal.Content>
      </Modal>
    );
  }

  render() {
    const { keys, listKeysRequestOut } = this.props;
    return (
      <div className="re is-main keys-page">
        <ConnectedKeysHeaderBar />

        { !keys.length && listKeysRequestOut && <Dimmer active><Loader /></Dimmer> }
        { keys.length ? this.renderKeysTable() : this.renderEmptyState() }
        <ConnectedKeyAuthModal />
        { this.renderErrorModal() }
      </div>
    );
  }
}

Keys.propTypes = {
  error: errorType,
  keys: PropTypes.arrayOf(keyType).isRequired,
  listKeysRequestOut: PropTypes.bool.isRequired,
  connectedClearError: PropTypes.func.isRequired,
  connectedListKeys: PropTypes.func.isRequired,
};

Keys.defaultProps = {
  error: undefined,
};

const mapStateToProps = state => ({
  error: state.keys.error,
  keys: state.keys.keys,
  listKeysRequestOut: state.keys.listKeysRequestOut,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedClearError: clearError,
  connectedListKeys: listKeys,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Keys);
